/**
 * Created on 3/1/2017.
 * Traditionally, the root reducer file is named index.js
 *
 * This rootReducer config object is passed to Redux.createStore() in
 * configurestore.{env}.js.
 */
import manifestReducer from '@ey/voltron-core/manifest-reducer.js';
import reducerManifest from './manifest.js';
import Env from '../util/env.js';
import errorReducer from './errorreducer';
import {
	engagementReducer,
	engagementTeamMembers,
	engagementMetaDataReducer,
	engagementUsersWithRoles,
	countryStatusReducer,
	engagementUserRolesReducer,
	rbacUserRolesReducer,
	workspaceReducer,
	paansReducer,
	getLanguagesReducer,
	getCountriesReducer,
	setEngagementIdReducer,
	setIsAresViewReducer,
	setServerPrintDataReducer,
	setIsDrawerModeReducer,
	setIsGuidedWorkFlowV2Reducer,
	setIsTrackChangesViewReducer,
	setIsCompareResponsesViewReducer,
	setHasBodyIdFilterReducer,
	setNavigationFilterReducer
} from './Engagements/engagementreducer';
import formActionsReducer from './Form/formActionsReducer'; //we all have to use the same reducer, use the form version, delete the engagement version
import configurationsReducer from './Configurations/configurationsreducer';
import {quickLinkReducer} from './Engagements/quicklinksreducer';
import appOnlineStateReducer from './apponlinestatereducer';
import connectivityStateReducer from './connectivitystatereducer';
import offlinePrepReducer from './offlineprepreducer';
import {userPreferencesReducer, internalUserReducer} from './userpreferences/userpreferencesreducer';
import userPresenceReducer from './UserPresence/userpresencereducer';
import {
	formProfileDataReducer,
	formBodyDataReducer,
	formBodyDisplayDataReducer,
	SubmitIndependenceDataReducer,
	formProfileUpdateDataReducer,
	SubmitIndependenceActionReducer,
	formOverwriteDataReducer,
	SubmitProfileDataReducer,
	IndividualIndependenceDocumentReducer,
	formBodyDisplayDataNoStoreUpdateReducer,
	formBodyDisplayDataForUpdateReducer
} from './FormData/formdatareducer';
import {
	accountAssertionsReducer,
	accountDetailsReducer,
	accountReducer,
	accountsReducer,
	currentAccountReducerSEM,
	areAllCanvasAccountsMappedToHelixAccountsReducer
} from './Accounts/accountsreducer';
import {documentsReducer, setDocumentIdReducer} from './Document/documentsreducer';
import limitedRiskDocumentsReducer from './Document/limitedRiskDocumentsReducer';
import entityDocumentReducer from './Document/entityDocumentReducer';
import {
	validationCountsReducer,
	validationDetailsReducer,
	withoutApprovalvalidationCountsReducer
} from './ValidationControl/validationcontrolreducer';
import {assertionsReducer} from './Assertions/assertionsreducer';
import {
	risksReducer,
	newRiskReducer,
	wcgwRelatedRisksReducer,
	riskReducer,
	relateRiskReducer
} from './Risk/riskreducer';
import riskTypeReducer from './RiskType/riskTypeReducer';
import riskFactorReducer from './RiskFactor/riskFactorReducer';
import {buildTasksReducer, taskListReducer, taskListReducerForWCGW} from './Task/tasklistreducer';
import {timephaseReducer} from './Timephase/timephasereducer';
import VersionUpgradeStateReducer from './versionreducer';
import relatedDocumentsReducer from './RelatedDocuments/relatedDocumentsReducer';
import {relatedObjectsReducer} from './RelatedObjects/relatedobjectsreducer';
import {sectionRelatedObjectsReducer} from './SectionRelatedObjects/sectionrelatedobjectsreducer';
import {modalOpenStateReducer, modalLevelStateReducer, adcModalOpenStateReducer} from './modalopenstatereducer';
import documentExtensionReducer from './Document/documentextensionreducer';
import signOffsReducer from './signoffsreducer';
import engagementCommentsReducer from './EngagementComment/engagementcommentreducer';
import formBodyRelatedDocumentsReducer from './FormBodyRelatedDocuments/formBodyRelatedDocumentsReducer';
import reviewNotesReducer from './ReviewNotes/reviewnotesreducer';
import docHelperDocumentsReducer from './Document/docHelperDocumentsReducer';
import snapshotsReducer from './Snapshot/snapshotsreducer';
import {
	snapshotDetailsReducer,
	formPrintReducer,
	snapshotCompareDetailsReducer,
	clearRightSideSnapshotViewReducer,
	showHideRightSideSnapshotViewReducer,
	showHideLeftSideSnapshotViewReducer
} from './Snapshot/snapshotdetailsreducer';
import {wcgwReducer, wcgwsReducer} from './WCGW/wcgwreducer';
import manageObjectsReducer from './ManageObjects/manageobjectsreducer';
import formUsersReducer from './FormUsers/formusersreducer';
import {contentUpdatesReducer} from './ContentUpdates/contentupdatesreducer';
import {itProcessReducer} from './ITProcess/itprocessreducer';
import {standaloneViewReducer} from './standaloneViewReducer';
import {documentLastModifiedDateReducer} from './documentLastModifiedDateReducer';
import {scotsDetailsReducer} from './Scots/scotsreducer';
import {scotsReducer, scotReducer} from './Scots/scotsreducer';
import {controlAttributesReducer} from './Attributes/controlAttributesReducer';
import {controlsDetailsReducer} from './Control/controlsReducer';
import {itcontrolDetailsReducer} from './ITControl/itcontrolReducer';
import {
	itApplicationDataReducer,
	itApplicationReducer,
	itApplicationDetailsReducer
} from './ITApplication/itapplicationreducer';
import {itRiskReducer} from './ITRisk/itriskreducer';
import pspIndexesReducer from './PSPIndexes/pspIndexesReducer';
import helixsnapshotreducer from './HelixSnapshot/helixsnapshotreducer';
import captureAnnotationReducer from './CaptureAnnotations/captureAnnotationReducer';
import engagementhelixreducer from './HelixIntegration/engagementhelixreducer';
import helixReducer from './HelixIntegration/helixreducer';
import materialityReducer from './Materiality/materialityreducer';
import journalSourceReducer from './JournalSource/journalsourcereducer';
import userValidationWithHelixProjectReducer from './HelixIntegration/uservalidationwithhelixprojectreducer';
import formReducer from './Form/formreducer';
import formBodyReducer from './Form/formBodyReducer';
import helixProjectFilterMetadataReducer from './HelixIntegration/helixprojectfiltermetadatareducer';
import assessRiskSummaryReducer from './AssessRiskSummary/assessRiskSummaryReducer';
import activeAnnotationReducer from './ActiveAnnotation/activeAnnotationReducer';
import fourFortyGlDocumentsReducer from './Document/fourFortyGlDocumentsReducer';
import duplicateDocumentsReducer from './Document/duplicateDocumentsReducer';
import userSearchReducer from './UserSearch/usersearchreducer';
import userSearchReducerGA from './UserSearch/usersearchreducerGA';
import userreducer from './User/userreducer';
import internalUsersReducer from './InternalUsers/internalusersreducer';
import bodiesSpecialReducer from './BodiesSpecial/bodiesSpecialReducer';
import loadingReducer from './loadingReducer';
import noteDetailsReducer from './NotesModal/rnhnotedetailreducer';
import workspaceEngagementsReducer from './WorkspaceEngagement/workspaceengagementsreducer';
import _assertionsReducer from './Assertions/_assertionreducer';
import _riskReducer from './Risk/_riskReducer';
import sampleItemReducer from './SampleItems/sampleItemReducer';
import filterDataReducer from './Filter/filterdatareducer.js';
import sampleListReducer from './SampleList/sampleListReducer.js';
import sampleItemDocumentReducer from './SampleItemDocuments/sampleItemDocumentsReducer.js';
/* Ares reducers */
import {reducers as aresReducers} from './guidedworkflow';
import {trialBalancesReducer, trialBalanceByIdReducer} from './TrialBalance/trialbalancereducer';
import {estimatesReducer} from './Estimates/estimatesReducer';
import {annotationsReducer} from './Annotations/annotationsreducer';
import {financialStatementReducer} from './FinancialStatement/financialstatementreducer';
import {multiEntityReducer, stEntitiesReducer} from './Ares/MultiEntities/stEntitiesreducer';
import uploadDocumentReducer from './Document/uploaddocumentreducer';
import groupAuditReducer from './GroupAudit';
import {setFormV2ToasterVisibilityReducer} from './toastreducer';
import topHeaderReducer from './TopHeader/topHeaderReducer';
/* Media Playing reducer */
import mediaPlayingReducer from './MediaPlaying/mediaplayingreducer.js';
import bulkRelateReducer from './Document/bulkRelateReducer';
import knowledgeFormsReducer from './Document/knowledgeFormsReducer.js';
import {manageAccountReducer, manageAccountsReducer} from './Accounts/manageaccountsreducer.js';
/*Flow chart */
import {flowChartReducer, flowChartsReducer} from './FlowChart/flowchartreducer.js';
import {flowchartstepReducer, flowchartstepEditModalReducer} from './FlowChart/flowchartstepreducer.js';
import projectReducer from './Projects/projectReducer.js';
import AIChatBotIntegrationParametersReducer from './Eyq/AIChatBotIntegrationParametersReducer';
import {adobeAnalytics} from '@ey/voltron-analytics';
import filterReducer from './Filter/filterreducer.js';
import tagsreducer from './Tags/tagsreducer.js';

export default manifestReducer(
	{
		...aresReducers,
		_assertions: _assertionsReducer,
		_risks: _riskReducer,
		account: accountReducer,
		accountAssertions: accountAssertionsReducer,
		accountDetails: accountDetailsReducer,
		accounts: accountsReducer,
		activeAnnotation: activeAnnotationReducer,
		annotations: annotationsReducer,
		apponlinestate: appOnlineStateReducer,
		appVersion: VersionUpgradeStateReducer,
		assertions: assertionsReducer,
		assessRiskSummary: assessRiskSummaryReducer,
		bodiesSpecial: bodiesSpecialReducer,
		buildTasks: buildTasksReducer,
		bulkRelate: bulkRelateReducer,
		captureAnnotation: captureAnnotationReducer,
		clearRightSideSnapshotView: clearRightSideSnapshotViewReducer,
		configurations: configurationsReducer,
		connectivitystate: connectivityStateReducer,
		contentUpdates: contentUpdatesReducer,
		controlAttributes: controlAttributesReducer,
		controlsDetails: controlsDetailsReducer,
		countries: getCountriesReducer,
		countryStatus: countryStatusReducer,
		currentAccountSEM: currentAccountReducerSEM,
		docHelperDocuments: docHelperDocumentsReducer,
		documentExtensions: documentExtensionReducer,
		documentId: setDocumentIdReducer,
		documents: documentsReducer,
		documentsLastModifiedInformation: documentLastModifiedDateReducer,
		duplicateDocuments: duplicateDocumentsReducer,
		engagement: engagementReducer,
		engagementComments: engagementCommentsReducer,
		engagementHelixProjects: engagementhelixreducer,
		engagementId: setEngagementIdReducer,
		engagementMetaData: engagementMetaDataReducer,
		engagementTeamMembers: engagementTeamMembers,
		engagementUserForIndependence: SubmitIndependenceDataReducer,
		engagementUsersWithRoles: engagementUsersWithRoles,
		entityDocuments: entityDocumentReducer,
		errors: errorReducer,
		estimates: estimatesReducer,
		financialStatement: financialStatementReducer,
		form: formReducer,
		formActions: formActionsReducer,
		formBodies: formBodyReducer,
		formBodyData: formBodyDataReducer,
		formBodyDisplayData: formBodyDisplayDataReducer,
		formBodyDisplayDataForUpdating: formBodyDisplayDataForUpdateReducer,
		formBodyDisplayDataNoStoreUpdate: formBodyDisplayDataNoStoreUpdateReducer,
		formBodyRelatedDocuments: formBodyRelatedDocumentsReducer,
		formOverwriteData: formOverwriteDataReducer,
		formPrintData: formPrintReducer,
		formProfileData: formProfileDataReducer,
		formProfileUpdateData: formProfileUpdateDataReducer,
		formUsers: formUsersReducer,
		fourFortyGlDocuments: fourFortyGlDocumentsReducer,
		groupAudit: groupAuditReducer,
		hasBodyIdFilter: setHasBodyIdFilterReducer,
		helixAccountsMappingStatus: areAllCanvasAccountsMappedToHelixAccountsReducer,
		helixProjectFilterMetadata: helixProjectFilterMetadataReducer,
		helixProjects: helixReducer,
		helixSnapshot: helixsnapshotreducer,
		independenceActionEngagementUser: SubmitIndependenceActionReducer,
		independenceIndividualDocumentId: IndividualIndependenceDocumentReducer,
		internalUser: internalUserReducer,
		internalUsers: internalUsersReducer,
		isAresView: setIsAresViewReducer,
		navigationFilter: setNavigationFilterReducer,
		serverPrintData: setServerPrintDataReducer,
		isCompareResponsesView: setIsCompareResponsesViewReducer,
		isDrawerMode: setIsDrawerModeReducer,
		isGuidedWorkFlowV2: setIsGuidedWorkFlowV2Reducer,
		isLoading: loadingReducer,
		isMediaPlaying: mediaPlayingReducer,
		isModalOpen: modalOpenStateReducer,
		isADCModalOpen: adcModalOpenStateReducer,
		modalLevel: modalLevelStateReducer,
		isStandaloneView: standaloneViewReducer,
		isTrackChangesView: setIsTrackChangesViewReducer,
		isValidUserWithProjectAvailable: userValidationWithHelixProjectReducer,
		itapplication: itApplicationReducer,
		itapplicationData: itApplicationDataReducer,
		itAppSODetails: itApplicationDetailsReducer,
		itcontrolDetails: itcontrolDetailsReducer,
		itprocess: itProcessReducer,
		itrisk: itRiskReducer,
		journalSource: journalSourceReducer,
		knowledgeForms: knowledgeFormsReducer,
		languages: getLanguagesReducer,
		limitedRiskDocuments: limitedRiskDocumentsReducer,
		manageObjects: manageObjectsReducer,
		materiality: materialityReducer,
		multiEntity: multiEntityReducer,
		newRisk: newRiskReducer,
		offlinePrep: offlinePrepReducer,
		paansUserData: paansReducer,
		pspIndexes: pspIndexesReducer,
		quickLink: quickLinkReducer,
		rbacRoles: rbacUserRolesReducer,
		relatedDocuments: relatedDocumentsReducer,
		relatedObjects: relatedObjectsReducer,
		reviewNotes: reviewNotesReducer,
		risk: riskReducer,
		riskFactors: riskFactorReducer,
		risks: risksReducer,
		riskTypes: riskTypeReducer,
		rnhNoteDetail: noteDetailsReducer,
		roles: engagementUserRolesReducer,
		sampleItems: sampleItemReducer,
		filterData: filterDataReducer,
		filter: filterReducer,
		sampleList: sampleListReducer,
		sampleItemDocuments: sampleItemDocumentReducer,
		scot: scotReducer,
		scots: scotsReducer,
		scotsDetails: scotsDetailsReducer,
		sectionRelatedObjects: sectionRelatedObjectsReducer,
		showHideLeftSideSnapshotView: showHideLeftSideSnapshotViewReducer,
		showHideRightSideSnapshotView: showHideRightSideSnapshotViewReducer,
		signOffs: signOffsReducer,
		snapshotCompareDetails: snapshotCompareDetailsReducer,
		snapshotDetails: snapshotDetailsReducer,
		snapshots: snapshotsReducer,
		stEntities: stEntitiesReducer,
		submitProfileDetails: SubmitProfileDataReducer,
		tagItems: tagsreducer,
		taskList: taskListReducer,
		timePhases: timephaseReducer,
		toasterDetails: setFormV2ToasterVisibilityReducer,
		topHeader: topHeaderReducer,
		trialBalance: trialBalanceByIdReducer,
		trialBalances: trialBalancesReducer,
		uploadDocuments: uploadDocumentReducer,
		userData: userSearchReducerGA,
		userDetail: userreducer,
		userPreferences: userPreferencesReducer,
		userPresence: userPresenceReducer,
		userSearchResults: userSearchReducer,
		validationdetails: validationDetailsReducer,
		validations: validationCountsReducer,
		withoutapprovalvalidations: withoutApprovalvalidationCountsReducer,
		wcgw: wcgwReducer,
		wcgws: wcgwsReducer,
		wcgwRelatedRisks: wcgwRelatedRisksReducer,
		relateRisks: relateRiskReducer,
		wcgwTasks: taskListReducerForWCGW,
		workspaceEngagements: workspaceEngagementsReducer,
		workspaceMetaData: workspaceReducer,
		manageAccounts: manageAccountsReducer,
		manageAccount: manageAccountReducer,
		flowChart: flowChartReducer,
		flowCharts: flowChartsReducer,
		flowchartStep: flowchartstepReducer,
		isFlowChartStepEditModelOpen: flowchartstepEditModalReducer,
		ovsProject: projectReducer,
		aiChatBotIntegrationParameters: AIChatBotIntegrationParametersReducer,
		adobeAnalytics: adobeAnalytics.adobeAnalyticsReducer
	},
	{
		manifest: reducerManifest,
		ignoreActions: ['HOME_LOGIN'],
		log: Env.allowDrydocks()
	}
);
